/*
Copyright© Celligence International, LLC - 2024

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained
access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.
*/

import { Box, Button, TextField } from '@mui/material';
import { useCallback, useState, useMemo } from 'react';
import LoadingModal from '../modals/LoadingModal';
import useAbortController from '../../common/hooks/useAbortController';
import { useAuthContext } from '../../contexts/AuthContext';
import Styles from '../../css/BulkDisbursementPage.module.css';
import axiosCall from '../../services/axios';

const UploadPayeeForm = () => {
  const { token } = useAuthContext();
  const { get } = useAbortController();
  const FormData = require('form-data');

  const [endpointStatus, setEndpointStatus] = useState('');
  const [response, setResponse] = useState(null);
  const [proctorUpdate, setProctorUpdate] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);

  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
    setResponse('');
  };

  const status = useMemo(() => {
    return endpointStatus;
  }, [endpointStatus])

  const handleProctorUpdateChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
      const value = event.target.checked;
      setProctorUpdate(value);
    }, []);

  const addPayees = useCallback(
    async (e) => {
      setEndpointStatus('loading');
      if (!token) return;
      const config = get();
      var bodyFormData = new FormData();
      bodyFormData.append('payeeFile', selectedFile);
      bodyFormData.append('metadata', new Blob([], { type: 'application/json' }));

      const headers = {
        'Session-Token': token,
        Accept: 'application/json',
      };
      try {
        setResponse(
          await axiosCall(
            {
              url: `live/servicing/miscPayee/upload?proctorUpdate=${proctorUpdate ? 'true' : 'false'}`,
              method: 'POST',
              data: bodyFormData,
            },
            config,
            headers,
          ),
        );
        setEndpointStatus('done');
        return true;
      } catch (e) {
        setEndpointStatus('error');
        console.log(e);
        return false;
      }
    },
    [get, FormData, selectedFile, token, proctorUpdate],
  );

  return (
      <div className={Styles.page}>
        {endpointStatus === 'loading' && <LoadingModal open={status === 'loading'} loadingMessage={'Loading'} />}
        <Box mt={1}>
          <Button variant='contained' component='label' className={Styles.paddedButton}>
            Choose File
            <input type='file' hidden onChange={handleFileChange} />
          </Button>
          {selectedFile && selectedFile.name}
        </Box>
        <h6>Please select a .xlsx or .xls file to proceed</h6>
        &nbsp;
        <Box mt={1}>
          Update Proctor Records?
          <input type='checkbox'
            name='proctorUpdate'
            checked={proctorUpdate}
            onChange={handleProctorUpdateChange}
          ></input>
        </Box>
        {selectedFile && (
          <Box mt={1}>
            <Button variant='contained' type='submit' onClick={addPayees} className={Styles.paddedButton}>
              Submit
            </Button>
          </Box>
        )}
        {response && (
          <Box mt={1}>
            <TextField className={Styles.page} label='Response: ' value={response.result[0]} />
          </Box>
        )}
      </div>
  );
};

export default UploadPayeeForm;
